<template>
    <div ref="container"  :class="containerClass">
        <!--
            $ver: v0.1.0
            배지와 함께 표시될 텍스트 영역입니다. 단순 문자열만 입력하는 경우가 일반적이고, ur-icon 컴포넌트를 활용하여 아이콘을 표시할 수 있습니다.
            #The text area to be displayed with the badge. It is common to enter only simple strings, and you can use the ur-icon component to display icons.
        -->
        <slot></slot>
        <div :class="badgeClass" v-if="!isHidden">{{notiValue}}</div>
    </div>
</template>

<script>
//ur-notification-badge는 배지의 형태로 업데이트 여부나 건수를 표시할 수 있는 컴포넌트 입니다.
//#ur-notification-badge is a component which can represent the notification of update and count.
import numberUtil from "../../../utils/static/numberUtil";
export default {
    name: "urNotificationBadge",
    data () {
        return{
            containerWidth: 0,
        }
    },
    props: {
        // $ver: v0.1.0
        // $v-model
        // Badge에 표시되는 숫자나 문자열값 입니다. Dot 형태의 배지인 경우 값을 입력해도 표시되지 않습니다.
        // #The number or string value displayed on the badge. If the badge is a dot, it will not display even if you enter a value
        // $default: null
        // $tags: IDE
        value: {
            type: [String,Number],
            default: null,
        },
        // $ver: v0.1.0
        // 텍스트 또는 아이콘과 겹쳐지게 표현할 지 여부입니다.
        // #Whether to overlap text or icons.
        // $default: false
        // $tags: IDE
        overlap: {
            type: Boolean,
            default: false,
        },
        // $ver: v0.1.0
        // dot 형태 표시 유형입니다. true일 경우 value와 상관없이 dot 형태로 표시됩니다.
        // # Whether to display the dot shape. If true, it is displayed in dot regardless of value.
        // $default: false
        // $tags: IDE
        dot: {
            type: Boolean,
            default: false,
        },
        // $ver: v0.1.0
        // notification badge의 표시 여부입니다. true일 경우 badge가 보이지 않습니다.
        // # Whether to display the notification badge. If true, the badge is not visible.
        // $default: false
        // $tags: IDE
        hidden: {
            type: Boolean,
            default: false,
        }
    },
    mounted() {
        if(this.$refs.container){
            this.containerWidth = this.$refs.container.clientWidth;
        }
        setTimeout(() => { // 길이를 바로 못 가져올 가능성이 있으므로 시간차로 한번 더 체크
            if(this.$refs.container){
                this.containerWidth = this.$refs.container.clientWidth;
            }
        }, 100);
    },
    computed: {
        notiValue(){
          return (numberUtil.isNum(this.value) && this.value >= 999)?   this.value+'+' : this.value;
        },
        isHidden() {
            //dot 일 경우는 hidden 여부만 따라가고, 내용을 표시하는 경우는 내용이 없을 경우도 숨김
            if(this.dot) {
                return this.hidden;
            } else {
                return this.hidden || !this.value || this.value.length === 0;
            }
        },
        containerClass() {
            let clazz = [];
            clazz.push('ur-notification-badge-container');
            clazz.push('ur-notification-badge-container__notification');
            return clazz;
        },
        badgeClass() {
            let clazz = [];
            clazz.push('ur-notification-badge');
            clazz.push('ur-notification-badge__badge-color-notification');

            if (this.dot) {
                clazz.push('ur-notification-badge__notification-dot');
            } else {
                clazz.push('ur-notification-badge__notification');
                if (this.value.length === 1) {
                    clazz.push('ur-notification-badge__notification-one-letter');
                } else {
                    clazz.push('ur-notification-badge__notification-multiple-letter');
                }
            }

            clazz.push('ur-notification-badge__notification-right-top');

            if(this.overlap){
                clazz.push('ur-notification-badge__notification-overlap');
            }
            return clazz;
        },
        badgeStyle() {
            let style = {};
            if (this.dot) {
                style['width'] = '4px';
                style['height'] = '4px';
                style['top'] = '-4px';
                style['left'] = '4px';
            } else if (this.value.length === 1) {
                style['width'] = '16px';
            } else {
                style['width'] = 'auto';
                style['padding-left'] = '8px';
                style['padding-right'] = '8px';
            }

            if(this.overlap){
                if(this.dot) {
                    style['top'] = '4px';
                    style['left'] = (this.containerWidth - 4) +'px';
                } else {
                    style['left'] = (this.containerWidth - 16) +'px';
                }
            }else{
                style['left'] = this.containerWidth + 'px';
            }

            return style;
        }
    }
}
</script>
